import { caClient } from '$lib/shopify.svelte';

import { customerOrdersQuery } from '$lib/customer/graphql/queries';
import type {
  GetCustomerOrdersQuery,
  GetCustomerOrdersQueryVariables,
} from '$lib/types-customer/customer.generated';

export async function getOrders(first = 20, after?: string) {
  const { data, errors } = await caClient().request<GetCustomerOrdersQuery>(
    customerOrdersQuery,
    { variables: { first, after } satisfies GetCustomerOrdersQueryVariables },
  );
  if (errors) throw new Error(errors.message);
  const conn = data!.customer!.orders;
  return {
    orders:   conn.edges.map(e => e.node),
    nextCursor: conn.pageInfo.hasNextPage ? conn.pageInfo.endCursor : null,
  };
}
